import react from "react";
import "../../style/common/footerBar.scss";
import { useNavigate } from "react-router-dom";
import React from "react";
import PagePath from "../../util/RoutePagePath";
import { routeToPage } from "../../util/RouteToPage";
import Instagram from "../../icon/Instagram";
import Facebook from "../../icon/Facebook";
import Twiter from "../../icon/Twiter";
import Youtube from "../../icon/Youtube";
import RightIcon from "../../icon/RightIcon";
import footImg from "../../image/foot.jpg";

const FooterBar = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <div className="relative">
        {/* background image */}
        {/* <img
          src={footImg}
          alt=""
          className="absolute left-0 top-0 -z-10 h-full w-full object-cover opacity-80"
        /> */}

        {/* mask */}
        <div className="absolute left-0 top-0 -z-10 h-full w-full bg-[#edeff0]"></div>

        {/* content */}
        <div className="tracking-6 mx-auto grid grid-cols-4 gap-20 px-20 py-10 text-[12px]">
          {/* CENTER */}
          <div>
            <ul className="space-y-4">
              <p className="text-[18px]">Shop Elvorloy</p>
              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.ABOUT_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  About Us
                </span>
              </li>

              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.CONTACT_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Contact Us
                </span>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-[20px]">Join The Trip</p>
            <div className="mt-4 flex items-center gap-4">
              <Facebook size={20} color="#000" />
              <Instagram size={20} color="#000" />
              <Twiter size={20} color="#000" />
            </div>
          </div>
          <div>
            <ul className="space-y-4">
              <p className="text-[18px]">Support</p>
              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.RETURN_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Returns, Refunds & Warranty Claims Policy
                </span>
              </li>
              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.SHIPPING_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Shipping Policy
                </span>
              </li>
              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.COOKIE_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Cookie Policy
                </span>
              </li>

              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.TERMS_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Terms of Service
                </span>
              </li>

              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.PRIVACY_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Privacy Policy
                </span>
              </li>
            </ul>
          </div>

          {/* RIGHT */}
          <div>
            <p className="text-[18px]">Exclusive Offers</p>
            {/* socials */}
            <p>
              Brenden Payne
              <br />
              TatumMabel71012@hotmail.com
              <br />
              992 Rampart pl
              <br />
              Stone Mountain
              <br />
              30088
              <br />
              United States of America
              <br />
              Georgia
              <br />
              Call us : +1 8566051810
            </p>
            {/* newsletter */}
            <div className="mt-5 flex max-w-[300px] items-center overflow-hidden border-b border-black p-2">
              <input
                type="text"
                placeholder="Email address
"
                className="h-[42px] flex-1 bg-transparent px-5 text-[14px] outline-none"
              />

              <button className="rounded-full bg-white px-2 py-2 text-[11px] uppercase tracking-[3px] transition duration-300 hover:scale-105 hover:bg-[#2a2a2a]">
                <RightIcon size={14} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FooterBar;
